import { ApiKeyEndPoint } from './api-key-endpoint';

export class ApiKeyDomain {
	public id: number;
	public name: string;
	public description: string;

	public endpoints: ApiKeyEndPoint[];

	constructor(apiKeyDomain?: ApiKeyDomain) {
		Object.assign(this, apiKeyDomain);

		if (apiKeyDomain?.endpoints) {
			this.endpoints = apiKeyDomain.endpoints.map(endpoint => new ApiKeyEndPoint(endpoint));
		}
	}
}
